import * as actionType from '../constants'

const defaultState = {
  medicalNeighborhoodProviders: [],
  loading: false,
  showModal: false,
  neighborhoodPracticeName: '',
}

const practiceProfileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_MEDICAL_NEIGHBORHOOD_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case actionType.GET_MEDICAL_NEIGHBORHOOD_SUCCESS:
      const medicalNeighborhoodProviders =
        action.payload.medicalNeighborhood &&
        action.payload.medicalNeighborhood.sort((a, b) => {
          if (a.practiceName < b.practiceName) {
            return -1
          }
          if (a.practiceName > b.practiceName) {
            return 1
          }
          return 0
        })
      return {
        ...state,
        medicalNeighborhoodProviders,
        neighborhoodPracticeName: action.payload.neighborhoodPracticeName,
        loading: false,
      }
    case actionType.GET_MEDICAL_NEIGHBORHOOD_FAILURE:
      return {
        ...state,
        medicalNeighborhoodProviders: [],
        loading: false,
      }
    case actionType.SEARCH_MEDICAL_NEIGHBORHOOD:
      const filteredMedicalNeighborhood =
        state.medicalNeighborhoodProviders &&
        state.medicalNeighborhoodProviders.filter(provider => {
          if (
            (provider?.providerNameTitle &&
              provider?.providerNameTitle
                .toLowerCase()
                .indexOf(
                  action.payload.searchText &&
                    action.payload.searchText.toLowerCase()
                ) !== -1) ||
            (provider?.practiceName &&
              provider?.practiceName
                .toLowerCase()
                .indexOf(
                  action.payload.searchText &&
                    action.payload.searchText.toLowerCase()
                ) !== -1)
          ) {
            if (
              action.payload.specialty &&
              action.payload.specialty.toLowerCase() ===
                provider.specialty.toLowerCase()
            ) {
              return true
            }
            if (action.payload.specialty === '') {
              return true
            }
          }
        })

      return {
        ...state,
        filteredMedicalNeighborhood,
      }

    case actionType.FILTER_MEDICAL_NEIGHBORHOOD_BY_SPECIALTY:
      const filteredMedicalNeighborhoodBySpecialty =
        state.medicalNeighborhoodProviders &&
        state.medicalNeighborhoodProviders.filter(provider => {
          if (
            provider?.specialty?.toLowerCase() ===
            action.payload.label.toLowerCase()
          ) {
            if (
              (action.payload.searchText &&
                provider?.providerNameTitle &&
                provider?.providerNameTitle
                  .toLowerCase()
                  .indexOf(
                    action.payload.searchText &&
                      action.payload.searchText.toLowerCase()
                  ) !== -1) ||
              (provider.practiceName &&
                provider.practiceName
                  .toLowerCase()
                  .indexOf(action.payload.searchText.toLowerCase()) !== -1)
            ) {
              return true
            }
            if (!action.payload.searchText) {
              return true
            }
          }
        })

      return {
        ...state,
        filteredMedicalNeighborhood: filteredMedicalNeighborhoodBySpecialty,
      }

    case actionType.GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST:
      return {
        ...state,
      }
    case actionType.GET_NEIGHBORHOOD_PROVIDER_DETAILS_SUCCESS:
      return {
        ...state,
        providerDetail: action.payload,
        showModal: true,
      }
    case actionType.GET_NEIGHBORHOOD_PROVIDER_DETAILS_FAILURE:
      return {
        ...state,
      }

    case actionType.CLOSE_PROVIDER_DETAIL:
      return {
        ...state,
        showModal: false,
      }

    default:
      return state
  }
}

export default practiceProfileReducer
